import { combineEpics } from 'redux-observable';
import deleteBoard from './delete-board/index.tsx';
import getActiveSprints from './get-active-sprints/index.tsx';

// @ts-expect-error - TS2769 - No overload matches this call.
export default combineEpics(deleteBoard, getActiveSprints);
